
try {
  module.exports = require('bluebird')
} catch (_) {
  module.exports = global.Promise
}



//////////////////
// WEBPACK FOOTER
// ./~/native-or-bluebird/promise.js
// module id = 29
// module chunks = 0 1